'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupWishlistButtons = exports.init = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _wishlist = require('../services/wishlist');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var WishlistButton = function () {
  function WishlistButton(el) {
    (0, _classCallCheck3.default)(this, WishlistButton);

    this.el = el;
    this.els = this.getEls();
    this.config = this.getConfig();
    this.isAdded = false;

    this.init();
  }

  (0, _createClass3.default)(WishlistButton, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.el.dataset.wishlistButtonInit = true;
      _wishlist.wishlistInstance.registerEntry(this.config.variantId, function (isAdded) {
        _this.setState(isAdded);
      });

      this.setupListeners();
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;
      this.el.addEventListener('click', function (e) {
        e.preventDefault();
        _this.toggleProductInWishlist();
      });
    }
  }, {
    key: 'toggleProductInWishlist',
    value: function toggleProductInWishlist() {
      var wishlistMethod = this.isAdded ? _wishlist.removeFromWishList : _wishlist.addToWishList;
      var _config = this.config,
          title = _config.title,
          variantId = _config.variantId,
          id = _config.id,
          handle = _config.handle,
          featuredImage = _config.featuredImage,
          price = _config.price;

      this.setState(!this.isAdded);
      this.setAnimation(!this.isAdded);

      wishlistMethod({ title: title, variantId: variantId, id: id, handle: handle, featuredImage: featuredImage, price: price }, function () {
        return _wishlist.wishlistInstance.updateWishlist();
      });
    }
  }, {
    key: 'setState',
    value: function setState(isAdded) {
      this.isAdded = isAdded;
      this.els.icon.classList.toggle('am-icon-heart-fill', isAdded);
      this.els.icon.classList.toggle('am-icon-heart', !isAdded);
    }
  }, {
    key: 'setAnimation',
    value: function setAnimation(isAdded) {
      var _config2 = this.config,
          addedClass = _config2.addedClass,
          removedClass = _config2.removedClass;

      if (addedClass) {
        this.el.classList.toggle(addedClass, !isAdded);
      }

      if (removedClass) {
        this.el.classList.toggle(removedClass, isAdded);
      }
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      var _el$dataset = this.el.dataset,
          title = _el$dataset.title,
          variantId = _el$dataset.variantId,
          id = _el$dataset.id,
          handle = _el$dataset.handle,
          featuredImage = _el$dataset.featuredImage,
          price = _el$dataset.price,
          addedClass = _el$dataset.addedClass,
          removedClass = _el$dataset.removedClass;

      return {
        title: title,
        variantId: parseInt(variantId),
        id: parseInt(id),
        handle: handle,
        featuredImage: featuredImage,
        price: price,
        addedClass: addedClass,
        removedClass: removedClass
      };
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;

      return {
        icon: (0, _functional.getElement)('.js-WishlistButton_Icon', { context: context })
      };
    }
  }]);
  return WishlistButton;
}();

var init = exports.init = function init(_ref) {
  var el = _ref.el;
  return new WishlistButton(el);
};

var setupWishlistButtons = exports.setupWishlistButtons = function setupWishlistButtons() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  (0, _functional.getElements)('[data-module="wishlist-button"', { context: context }).filter(function (el) {
    return !el.dataset.wishlistButtonInit;
  }).forEach(function (el) {
    return new WishlistButton(el);
  });
};